var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessingBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_987_2437)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_987_2437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.25 11H14.75C13.7554 11 12.8016 11.3951 12.0983 12.0983C11.3951 12.8016 11 13.7554 11 14.75V14.75C11 15.3467 11.2371 15.919 11.659 16.341C12.081 16.7629 12.6533 17 13.25 17H26.75C27.3204 17.007 27.8717 16.7948 28.2904 16.4073C28.709 16.0198 28.963 15.4865 29 14.9173C29.0221 14.411 28.9414 13.9056 28.7629 13.4314C28.5844 12.9572 28.3118 12.524 27.9614 12.158C27.611 11.7919 27.1901 11.5007 26.7241 11.3016C26.2581 11.1026 25.7567 11 25.25 11V11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 18.4999H12.5C12.3011 18.4999 12.1103 18.579 11.9697 18.7196C11.829 18.8603 11.75 19.051 11.75 19.2499V25.2499C11.7512 26.2441 12.1467 27.1973 12.8497 27.9003C13.5527 28.6033 14.5058 28.9987 15.5 28.9999H24.5C25.4942 28.9987 26.4473 28.6033 27.1503 27.9003C27.8533 27.1973 28.2488 26.2441 28.25 25.2499V19.2499C28.25 19.051 28.171 18.8603 28.0303 18.7196C27.8897 18.579 27.6989 18.4999 27.5 18.4999ZM22.25 22.2499H17.75C17.5511 22.2499 17.3603 22.1709 17.2197 22.0303C17.079 21.8896 17 21.6989 17 21.4999C17 21.301 17.079 21.1103 17.2197 20.9696C17.3603 20.829 17.5511 20.7499 17.75 20.7499H22.25C22.4489 20.7499 22.6397 20.829 22.7803 20.9696C22.921 21.1103 23 21.301 23 21.4999C23 21.6989 22.921 21.8896 22.7803 22.0303C22.6397 22.1709 22.4489 22.2499 22.25 22.2499Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_987_2437",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C80E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_2437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingBanner);
export default __webpack_public_path__ + "static/media/processing_banner.9c1c08f787b64f8b8208f6aba42016a6.svg";
export { ForwardRef as ReactComponent };